import React,{useState} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";

function WholeWheatCakes() {
    const handleClickButton = (paths) => {
        window.location.href = paths;
    };
const [activeKey, setActiveKey] = useState(null);
    const accordionData = [
      {
        title: "Are your whole wheat cakes 100% maida-free?",
        content: "Yes. We do not use maida at all — only 100% whole wheat flour.",
      },
      {
        title: "Do you offer eggless whole wheat cakes?",
        content: "Yes, all cakes are available in eggless vegetarian versions.",
      },
      {
        title: "Do your cakes contain preservatives?",
        content: "No. All products are preservative-free and made fresh daily.",
      },
      {
        title: "Do you deliver across Chennai?",
        content: "Yes, including T. Nagar, Nungambakkam, Adyar, Velachery, and more.",
      },
      {
        title: "Can I get low-sugar or jaggery cakes?",
        content: "Yes — we offer jaggery-based whole wheat cakes.",
      },
      {
        title: "Do you make custom birthday cakes?",
        content: "Yes. We make healthy birthday cakes with custom designs.",
      },
    ];
      
  return (
    <>
    <Helmet>
      <title>Whole Wheat Cake – Natural, Eggless & No-Maida Cakes Chennai</title>
      {/* <meta
        name="description"
        content="Find answers about natural ingredient cakes, no-maida baking, healthy whole wheat treats & Chennai cake delivery."
      /> */}
      <link rel="canonical" href="https://wheatbakes.com/whole-wheat-cakes" />

    </Helmet>
      
    <Container className="my-5">
      <Row>
            <p className="text-align-center brown-text-color text-bold-600">
              WHOLE WHEAT CAKES
            </p>
            <h1 className="text-align-center text-bold-600">
                Whole Wheat Cakes — Eggless, Healthy & Maida-Free
            </h1>
      </Row>
      {/* HERO SECTION */}
      <Row className="align-items-center mb-5">
        <Col lg={6}>
          <p className="mt-3 wheatbakes-para-justify">
            At WheatBakes, we bake 100% whole-wheat cakes using real, natural
            ingredients — no maida, no preservatives, and no added colours.
            Each cake is made fresh in Chennai with healthier sweeteners like
            brown sugar or jaggery, making it perfect for families, kids,
            fitness-conscious customers, and anyone looking for truly healthy
            cakes without compromising taste.
          </p>
          <p className="wheatbakes-para-justify">
            Order whole wheat cakes online for fast delivery across Chennai
            including T. Nagar, or choose eggless, low-sugar, and custom options.
          </p>

          <div className="mt-4 d-flex gap-3 flex-wrap">
            <div className="my-4 text-center" data-aos="fade-up">
                <button className="wheatbakes-btn" onClick={()=>handleClickButton("https://wheatbakes.com/menu")}>Order Now</button>
            </div>
          </div>
        </Col>

        <Col lg={6}>
          {/* <PlaceholderImage alt="Whole Wheat Cakes Image" /> */}
          <img className="w-100" src="images/product/cup_cakes.jpg" alt="bakery" />
        </Col>
      </Row>

      {/* WHY CHOOSE SECTION */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 mb-4">
          Why Choose Whole Wheat Cakes? (Healthier, Lighter & More Nutritious)
        </h2>

        <Row className="g-4">
          {[
            {
              title: "More Fiber, Less Guilt",
              text: "Whole wheat helps support digestion and keeps you fuller.",
            },
            {
              title: "No Maida — 100% Clean Baking",
              text: "Our cakes contain zero refined flour, making them ideal for conscious eaters.",
            },
            {
              title: "No Preservatives, No Artificial Colours",
              text: "Every cake is made fresh daily from scratch — no chemicals, no shortcuts.",
            },
            {
              title: "Eggless Options Available",
              text: "We specialize in eggless whole wheat cakes, perfect for vegetarians.",
            },
            {
              title: "Sweetened Naturally",
              text: "Choose between brown sugar or jaggery cakes for a wholesome dessert experience.",
            },
          ].map((item, idx) => (
            <Col md={4} key={idx}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <h5 className="fw-bold green-text"><span style={{ color: "#0DAF50", marginRight: "8px" }}>✔</span> {item.title}</h5>
                  <p className="mb-0">{item.text}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>

        {/* CAKE RANGE */}
        <Row className="align-items-center mb-5">  
            {/* Image column */}
            <Col
                xl={6}
                lg={6}
                md={12}
                className="order-1 order-lg-2 py-5"
            >
                <img className="w-100" src="images/home/plaincake.png" alt="bakery" />
            </Col>

            {/* Content column */}
            <Col
                xl={6}
                lg={6}
                md={12}
                className="order-2 order-lg-1 py-5"
            >
                <h2 className="fw-bold text-bold-600">Our Whole Wheat Cake Range</h2>

                <p className="wheatbakes-para-justify">
                Our signature collection includes classic and premium cakes made
                with 100% whole wheat, natural ingredients, and handcrafted methods.
                </p>

                <p className="fw-semibold mb-2">
                Popular Options (All Eggless Available):
                </p>

                <ul>
                <li>Whole Wheat Chocolate Cake</li>
                <li>Jaggery Vanilla Cake</li>
                <li>Whole Wheat Blueberry Cake</li>
                <li>Ragi & Millet Cake</li>
                <li>Whole Wheat Cookies & Pastries</li>
                <li>Whole Wheat Brownies (Delivery Available)</li>
                </ul>

                <div className="my-4" data-aos="fade-up">
                <button
                    className="wheatbakes-btn-light"
                    onClick={() =>
                    handleClickButton("https://wheatbakes.com/menu")
                    }
                >
                    Explore Complete Menu
                </button>
                </div>
            </Col>

        </Row>


        {/* INGREDIENTS */}
        <Row className="align-items-center mb-5">
            <Col lg={6}>
                <img className="w-100" src="images/home/milletbrownies.png" alt="bakery" />
            </Col>
            <Col lg={6}>
            <h2 className="fw-bold text-bold-600">Made With Natural, Clean Ingredients</h2>
            <p className="wheatbakes-para-justify">At WheatBakes, every cake starts with ingredients you can trust:</p>
            <ul>
                <li>100% Whole Wheat Flour</li>
                <li>Butter, Jaggery (you choose)</li>
                <li>Fresh Fruits & Cocoa</li>
                <li>No Artificial Colours</li>
                <li>No Preservatives</li>
                <li>No Synthetic Flavours</li>
            </ul>
            <p className="wheatbakes-para-justify">
                This makes our cakes suitable for kids, elderly, health-conscious
                individuals, and anyone preferring natural ingredient cakes over
                commercial bakery options.
            </p>
            </Col>
        </Row>

      {/* OCCASIONS */}
      <Row className="align-items-center mb-5">
        <Col lg={6}>
            <h2 className="fw-bold text-bold-600">Perfect for Birthdays, Kids & Special Occasions</h2>
            <p>Looking for healthy birthday cakes in Chennai?</p>
            <ul>
            <li>100% whole-wheat base</li>
            <li>Jaggery-sweetened versions</li>
            <li>Eggless / pure vegetarian options</li>
            </ul>
            <p>
                We deliver fresh to T. Nagar, Kodambakkam, Nungambakkam,
                Ashok Nagar, and nearby locations.
            </p>

            <h2 className="fw-bold text-bold-600">Delivery Across Chennai (Including T. Nagar)</h2>
            <ul>
                <li>Fast delivery across T. Nagar Chennai</li>
                <li>Free delivery in T. Nagar (minimum order applies)</li>
                <li>Freshly baked cakes delivered within hours</li>
                <li>Eco-friendly packaging</li>
            </ul>
            <div className="my-4" data-aos="fade-up">
                <button className="wheatbakes-btn-light" onClick={()=>handleClickButton("https://wheatbakes.com/menu")}>Place Your Order</button>
            </div>
        </Col>
        <Col lg={6}>
            <img className="w-100" src="images/product/shop.jpg" alt="bakery" />
        </Col>
      </Row>

      {/* REVIEWS */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 text-center">Customer Reviews</h2>
        <p className="fw-semibold text-bold-600">⭐ 4.9 / 5 — Loved by Health-Conscious Families in Chennai</p>
        <Row className="g-4">
          {[
            {
              text:
                "The best whole wheat chocolate cake I have ever tasted. Perfect sweetness and totally guilt-free.",
              author: "Priya, T. Nagar",
            },
            {
              text:
                "Finally a bakery that uses no preservatives. My kids love their jaggery vanilla cake.",
              author: "Raghu, Nungambakkam",
            },
            {
              text:
                "Amazing texture for a maida-free cake. Highly recommended!",
              author: "Harini, Kodambakkam",
            },
          ].map((review, idx) => (
            <Col md={4} key={idx}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <p>“{review.text}”</p>
                  <p className="fw-semibold mb-0">— {review.author}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>

      {/* FAQ */}
      <section className="mb-5">
        <h2 className="fw-bold text-bold-600 text-center">Frequently Asked Questions</h2>
        
        <div className="wheatbakes-accordian-container dark-text">
          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}
          >
            {accordionData.map((item, index) => (
              <Accordion.Item
                key={index}
                eventKey={String(index)}
                className={
                  activeKey === String(index) ? "accordion-item-active" : ""
                }
              >
                <Accordion.Header>{item.title}</Accordion.Header>
                <Accordion.Body>{item.content}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="text-center py-5 bg-light rounded">
        <h2 className="fw-bold mb-3 text-bold-600">Order Whole Wheat Cakes Online</h2>
        <p className="wheatbakes-para-justify">
          Enjoy delicious, soft, healthy cakes without guilt.
          Order your whole wheat cake online today — baked fresh and delivered across Chennai.
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">          
          <button className="wheatbakes-btn" onClick={()=>handleClickButton("https://wheatbakes.com/menu")}>Order Now</button>
          <button className="wheatbakes-btn-light" onClick={()=>handleClickButton("https://wheatbakes.com/contact")}>Contact Page</button>
        </div>
      </section>

    </Container>
    </>
  );
}

export default WholeWheatCakes;
